export default __webpack_public_path__ + "static/media/profile-cover-1.198e5dc9.jpeg";